import React, { ReactNode } from 'react';

interface TabProps {
    active: boolean;
    onClick: () => void;
    icon?: ReactNode;
    children: ReactNode;
    className?: string;
}

const Tab: React.FC<TabProps> = ({
    active,
    onClick,
    icon,
    children,
    className = ''
}) => {
    return (
        <button
            onClick={onClick}
            className={`
        flex items-center px-4 py-2 text-sm font-medium transition-colors duration-200
        border-b-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        ${active
                    ? 'border-blue-500 text-blue-600 bg-blue-50'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
        ${className}
        `}
        >
            {icon}
            {children}
        </button>
    );
};

export default Tab;